import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { SalesAvailabilityState } from '../../store/sales-availability/sales-availability.reducer';
import * as fromActions from '../../store/sales-availability/sales-availability.actions';
import * as fromSelector from '../../store/sales-availability/sales-availability.selectors';
import { Observable, Subject } from 'rxjs';
import { MasterSlot, ShopMaxPerDay, SlotsPerDay } from '../../shared/models/slot-management.model';
import { Department, TransportationType } from '@signal/asp-data-commons';
import { ConfirmDialogComponent } from '../../shared/components/confirm-dialog/confirm-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { INavigateAway } from '../../shared/guards/NavigationGuard';
import { exitConfig, unsubscribeSubscriptions } from '../../shared/services/util.service';
import { SubscriptionList } from '../../shared/models/asp.types';


@Component({
  selector: 'app-sales-transport-capacity',
  templateUrl: './sales-transport-capacity.component.html',
  styleUrls: ['./sales-transport-capacity.component.scss']
})
export class SalesTransportCapacityComponent implements OnInit,INavigateAway, OnDestroy {

  viewMode = 'Remote';
  remoteMaxTotal$: Observable<ShopMaxPerDay[]>;
  slotDetails$: Observable<SlotsPerDay[]>;
  maxAndMasterSlots$: Observable<{ max: any, masterSlot: MasterSlot[] }>;
  masterSlotsLoading$: Observable<boolean>;
  tableValueInfo = [
    {value : 'departmentCapacity.blank', description : 'departmentCapacity.notLimitedToANumberOfAppointmentsForTheTimePeriod'},
    {value : '0', description : 'departmentCapacity.blocksTheTimePeriod'},
    {value : 'departmentCapacity.numericValue', description : 'departmentCapacity.setsANumberOfAppointmentsForTheTimePeriod'}]

  //save clicked 
  isSavedClicked=false;
  isRemoteSlotsPerDaySaveClicked=false

  //cancel clicked
  isCancelClicked=false;
  isRemoteMaxSlotsPerTimeTableCancleClicked=false

 //forms edited
  isRemoteMaxSlotsPerDayEdited=false;
  isRemoteMaxSlotsPerTimeTableEdited=false;
  bothFormsEdited=false;
  slotsUpdated$:Observable<boolean>;
  private subs: SubscriptionList = {};

  constructor(private readonly slotState: Store<SalesAvailabilityState>,
    private cdr: ChangeDetectorRef,
    private dialog: MatDialog) {
    this.slotState.dispatch(new fromActions.LoadMasterSlots());

    this.slotState.dispatch(new fromActions.LoadTransportMaxTotal({transport: TransportationType.REMOTE}));
    this.remoteMaxTotal$ = this.slotState.select(fromSelector.selectRemoteMaxTotal);

    this.slotState.dispatch(new fromActions.LoadTransportMaxSlots({transport: TransportationType.REMOTE}));
    this.slotDetails$ = this.slotState.select(fromSelector.selectRemoteMaxSlots);

    this.maxAndMasterSlots$ = this.slotState.select(fromSelector.selectMaxAndMasterSlots, { view: this.viewMode });
    this.masterSlotsLoading$ = this.slotState.select(fromSelector.selectMasterSlotsLoading);
    this.slotsUpdated$=this.slotState.select(fromSelector.selectRemoteSlotsUpdated);
   }

   canExit():Observable<boolean> { 
    const result = new Subject<boolean>();
    const dialogRef = this.dialog.open(ConfirmDialogComponent, exitConfig
      ); 
    this.subs.dialogRef = dialogRef.afterClosed().subscribe(event => {
    
      if (event.action === 'confirm') {
        this.onSaveClicked();
        this.subs.slotUpdate = this.slotsUpdated$.subscribe(data=>{
          if(data)
          {
            result.next(true);
            result.complete();
          }
        });
      }
      else if(event.action === 'close'){
        result.next(true);
        result.complete();
      }else{}
    });
    return result.asObservable(); 
  };

  ngOnInit(): void {
  }
  
  ngAfterContentChecked(): void { 
    if (!this.cdr['destroyed']) {
      this.cdr.detectChanges();
    }
  }

  onTotalSaveChanges(slotDetails){
    this.slotState.dispatch(new fromActions.UpdateTransportMaxTotal(
      {
        transport: TransportationType.REMOTE,
        transportMaxTotal : slotDetails
      }));
  }

  onSlotsSaveChanges(slotDetails){
  this.slotState.dispatch(new fromActions.UpdateTransportMaxSlots(
      { transport: TransportationType.REMOTE, transportMaxSlots: slotDetails ,bothFormsEdited:this.bothFormsEdited}
    ));
   this.isSavedClicked=false;
  }

   // returns if the forms are edited
   formsNotEdited()
   {
     return !this.isRemoteMaxSlotsPerDayEdited && !this.isRemoteMaxSlotsPerTimeTableEdited;
   }

  //save button clicked
  onSaveClicked()
  {
    this.isRemoteSlotsPerDaySaveClicked=this.isRemoteMaxSlotsPerDayEdited?true:false
    this.isSavedClicked=this.isRemoteMaxSlotsPerTimeTableEdited?true:false
    this.bothFormsEdited=(this.isRemoteMaxSlotsPerDayEdited && this.isRemoteMaxSlotsPerTimeTableEdited) && this.isRemoteMaxSlotsPerTimeTableEdited?true:false
    // detect changes after manually calling onSaveClicked()
    if (!this.cdr['destroyed']) {
      this.cdr.detectChanges();
    }
  }

  //cancel button clicked 
  onCancelClicked()
  {
    this.isCancelClicked=this.isRemoteMaxSlotsPerDayEdited?true:false;
    this.isRemoteMaxSlotsPerTimeTableCancleClicked=this.isRemoteMaxSlotsPerTimeTableEdited?true:false;
  }

  //reset cancle button clicked value for 1st form
  resetCancleClickValue(event)
  {
    this.isCancelClicked=event;
    this.isRemoteMaxSlotsPerDayEdited=event;
  }

   //reset cancle button clicked value for 2nd form
   resetCancleClickedPerTimePeriod(event)
  {
    this.isRemoteMaxSlotsPerTimeTableCancleClicked=event;
    this.isRemoteMaxSlotsPerTimeTableEdited=event;
  }

  //reset save button value for 1st from
  resetSaveClickedValue(event)
  {
    this.isRemoteSlotsPerDaySaveClicked=event;
    if (!this.cdr['destroyed']) {
      this.cdr.detectChanges();
    }
  }

  //Appointment per day form edited 
  remoteMaxSlotsPerDayFormEdited(event)
  { 
    this.isRemoteMaxSlotsPerDayEdited=event;
  }

  //Appointment per time period form edited 
  remoteMaxSlotsPerTimeTableFormEdited(event)
  {
    this.isRemoteMaxSlotsPerTimeTableEdited=event;
  }

  ngOnDestroy() {
    unsubscribeSubscriptions(this.subs);
    this.cdr.detach();
  }

}
